import React from 'react';
import styled from 'styled-components';

export const Checkbox = ({
  checkedValue,
  group,
  labelStyle,
  onClick,
  text,
  value,
}) => {
  return (
    <>
      <input
        checked={checkedValue === value}
        id={`${group}_${text}_${value}`}
        name={group}
        onChange={(e) => onClick(e.currentTarget.value)}
        type="checkbox"
        value={value}
      />
      <Label htmlFor={`${group}_${text}_${value}`} style={labelStyle}>
        {text}
      </Label>
    </>
  );
};

export default Checkbox;

const Label = styled.label`
  :hover {
    cursor: pointer;
  }
`;
